import { APIGet, APIPost, APIPut, APIDelete, APIUrl, AdminType } from "api/protocols";

//Food Ordering
//GET Food Ordering Settings
export async function GetFoodOrderingSettings(params: any, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.Guest, "/facility/food-ordering/settings"), params, useGlobalLoader);
}

interface IPutFoodOrderingSettings {
  enabled: boolean;
  allow_off_course_orders: boolean;
  allow_on_course_orders: boolean;
  allow_on_course_deliveries: boolean;
  mark_orders_as_overtime: boolean;
  // overtime_minutes: string;
  print_orders_in_kitchen: boolean;
  print_orders: boolean;
  print_order_details_in_kitchen: boolean;
  send_confirmation_text: boolean;
  send_prep_time_text: boolean;
  send_ready_text: boolean;
  pay_at_counter: boolean;
  pay_online: boolean;
  pay_on_account: boolean;
  contact_name: string;
  contact_phone: string;
}

//PUT Food Ordering Settings
export async function PutFoodOrderingSettings(params: IPutFoodOrderingSettings, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.Guest, "/facility/food-ordering/settings"), params, useGlobalLoader);
}

interface IGetFoodOrderingCategory {
  facility_id: number;
  id?: number; //don't pass for full list of categories on facility
}
interface IDeleteFoodOrderingCategory {
  id: number;
}
interface IPostFoodOrderingCategory {
  title: string;
}
interface IPutFoodOrderingCategory {
  id: number;
  title: string;
}

//GET Food Ordering Categories
export async function GetFoodOrderingCategories(params: IGetFoodOrderingCategory, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.Guest, "/facility/food-ordering/category"), params, useGlobalLoader);
}
//DELETE Food Ordering Categories
export async function DeleteFoodOrderingCategories(params: IDeleteFoodOrderingCategory, useGlobalLoader: boolean) {
  return await APIDelete(APIUrl(AdminType.Guest, "/facility/food-ordering/category"), params, useGlobalLoader);
}
//POST Food Ordering Categories
export async function PostFoodOrderingCategories(params: IPostFoodOrderingCategory, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.Guest, "/facility/food-ordering/category"), params, useGlobalLoader);
}
//PUT Food Ordering Categories
export async function PutFoodOrderingCategories(params: IPutFoodOrderingCategory, useGlobalLoader: boolean) {
  return await APIPut(APIUrl(AdminType.Guest, "/facility/food-ordering/category"), params, useGlobalLoader);
}

interface IGetFoodOrderingCategoryProduct {
  facility_id: number;
  category_id?: number;
}
interface IPostFoodOrderingCategoryProduct {
  category_id: number;
  product_ids: Array<number>;
}

//GET Food Ordering Category Products
export async function GetFoodOrderingCategoryProducts(
  params: IGetFoodOrderingCategoryProduct,
  useGlobalLoader: boolean,
) {
  return await APIGet(APIUrl(AdminType.Guest, "/facility/food-ordering/category/product"), params, useGlobalLoader);
}

//POST Food Ordering Category Product
export async function PostFoodOrderingCategoryProduct(
  params: IPostFoodOrderingCategoryProduct,
  useGlobalLoader: boolean,
) {
  return await APIPost(APIUrl(AdminType.Guest, "/facility/food-ordering/category/product"), params, useGlobalLoader);
}

//DELETE Food Ordering Category Product
export async function DeleteFoodOrderingCategoryProduct(
  params: IPostFoodOrderingCategoryProduct,
  useGlobalLoader: boolean,
) {
  return await APIDelete(APIUrl(AdminType.Guest, "/facility/food-ordering/category/product"), params, useGlobalLoader);
}

interface IGetFoodOrderingPickupLocations {
  facility_id: number;
}

//GET Pickup Locations
export async function GetFoodOrderingPickupLocations(
  params: IGetFoodOrderingPickupLocations,
  useGlobalLoader: boolean,
) {
  return await APIGet(APIUrl(AdminType.Guest, "/facility/food-ordering/pickup-location"), params, useGlobalLoader);
}

interface IPostFoodOrderingOrder {
  order_id: number;
  tee: string;
  pickup_location_id?: number;
  pickup_time?: string;
}

//POST Food Ordering Order
export async function PostFoodOrderingOrder(params: IPostFoodOrderingOrder, useGlobalLoader: boolean) {
  return await APIPost(APIUrl(AdminType.Guest, "/facility/food-ordering/order"), params, useGlobalLoader);
}
